"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderProgress = void 0;
const SliderProgress_1 = __importDefault(require("./SliderProgress"));
exports.SliderProgress = SliderProgress_1.default;
